import { toast } from "react-toastify";
import { ApiConfiguration } from "../../../services/http/api-configuration";
import ApiService from "../../../services/http/api-service";

export const dashboardDetail = async () => {
	try {
		const res = await ApiService.get(ApiConfiguration.dashbaord);
		return res.data;
	} catch (err) {
		toast.error(err.response.data.message);
		throw new Error(err);
	}
};

export const categoryList = async () => {
	try {
		const res = await ApiService.get(ApiConfiguration.categoryList);
		return res.data;
	} catch (err) {
		toast.error(err.response.data.message);
		throw new Error(err);
	}
};
export const productList = async (parma) => {
	try {
		const res = await ApiService.get(
			ApiConfiguration.productList +
				`?category_id=${parma.cat_id}&product_type=${parma.product_type}`
		);
		return res.data;
	} catch (err) {
		toast.error(err.response.data.message);
		throw new Error(err);
	}
};

export const productDetail = async (parma) => {
	try {
		const res = await ApiService.get(
			ApiConfiguration.productDetail + `?product_id=${parma.product_id}`
		);
		return res.data;
	} catch (err) {
		toast.error(err.response.data.message);
		throw new Error(err);
	}
};

export const claimProduct = async (payload) => {
	try {
		const res = await ApiService.post(ApiConfiguration.claimProduct, payload);
		return res.data;
	} catch (err) {
		toast.error(err.response.data.message);
		throw new Error(err);
	}
};

export const userProfileDetails = async () => {
	try {
		const res = await ApiService.get(ApiConfiguration.userProfileDetails);
		return res;
	} catch (err) {
		toast.error(err.response.data.message);
		throw new Error(err);
	}
};

export const getOrderDetails = async (params) => {
	try {
		const res = await ApiService.get(
			ApiConfiguration.orderDetails + `?category_id=${params.cat_id}`
		);
		return res.data;
	} catch (err) {
		toast.error(err.response.data.message);
		throw new Error(err);
	}
};
export const getSubscriptionInvoiceDetails = async () => {
	try {
		const res = await ApiService.get(
			ApiConfiguration.subscriptionInvoiceDetails
		);
		return res.data;
	} catch (err) {
		toast.error(err.response.data.message);
		throw new Error(err);
	}
};
export const getOrderOrderDetailsOnID = async (id) => {
	try {
		const res = await ApiService.get(
			ApiConfiguration.orderInvoiceDetails + `?product_id=${id}`
		);
		return res.data;
	} catch (err) {
		toast.error(err.response.data.message);
		throw new Error(err);
	}
};
